import { Injectable } from '@angular/core';
import { Resolve, Router} from '@angular/router';
import { MetaService } from '@ngx-meta/core';
import { StorageService } from '../_services/storage.service';
import { TranslateService } from '@ngx-translate/core';
import { LocalizeRouterService } from 'localize-router';
import { map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable()
export class MainResolver implements Resolve<any> {

  constructor(
    private translate: TranslateService,
    private router: Router,
    private storage: StorageService,
    private localize: LocalizeRouterService
    ) {
  }

  resolve() {
    const lingua = this.localize.parser.currentLang;

    return this.storage.getMappone(lingua).pipe(switchMap((mappa => {

      if (this.storage.isBrowser) {
        console.log( 'MainResolver -> ', lingua, ', ', mappa);
      }

      const lingue = [];
      mappa.lingue.forEach(l => lingue.push(l.codice.toLowerCase()));
      const linguaDefault = mappa.lingue.find(l => l.flDefault).codice.toLowerCase();

      if (!lingua || !lingue.find(l => l === lingua)) {
        return this.translate.use(linguaDefault).pipe(map(() => {
          console.log('Lingua non  trovata, redirigo verso /' + linguaDefault);
          this.router.navigate(['/' + linguaDefault]);
        }));
      }

      return of({});
    })));
  }

}
